import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  border: 0;
  background-color: #f5f5f5;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`

export const ContainerOutlet = styled.div`
  padding: 3rem 4rem;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  height: calc(100vh - 64px);
`
